
import { createBrowserRouter } from "react-router-dom";
import AuthGuard from "./guards/AuthGuard"; // 👈 import the guard

import AdminPunchmark from "./pages/admin/mobile/Punchmark";
import AdminAttendance from "./pages/admin/mobile/Attendance";
import AdminAttendanceform from "./pages/admin/mobile/AttendanceRegularization";
import AdminLeave from "./pages/admin/mobile/Leave";
import AdminLeaveform from "./pages/admin/mobile/Leaveform";
import AdminPayroll from "./pages/admin/mobile/Payroll";
import AdminHolidaylist from "./pages/admin/mobile/Holidaylist";
import AdminProfile from "./pages/admin/mobile/Profile";
import AdminAttendanceLog from "./pages/admin/mobile/Attendance_log";

import AdminApprovals from "./pages/admin/mobile/Approvals";
import AdminMyapproval from "./pages/admin/mobile/Myapproval";
import AdminTeamAttendance from "./pages/admin/mobile/TeamAttendance";


import Login from "./pages/auth/Login";
import PrivacyPolicy from "./pages/auth/PrivacyPolicy";

import UserApprovals from "./pages/user/mobile/Approvals";
import UserMyapproval from "./pages/user/mobile/Myapproval";
import UserMobileDashboard from "./pages/user/mobile/Dashboard";
import UserDesktopDashboard from "./pages/user/desktop/Dashboard";
import Punchmark from "./pages/user/mobile/Punchmark";
import Attendance from "./pages/user/mobile/Attendance";
import Attendanceform from "./pages/user/mobile/AttendanceRegularization";
import Leave from "./pages/user/mobile/Leave";
import Leaveform from "./pages/user/mobile/Leaveform";
import Payroll from "./pages/user/mobile/Payroll";
import Holidaylist from "./pages/user/mobile/Holidaylist";
import Profile from "./pages/user/mobile/Profile";
import AttendanceLog from "./pages/user/mobile/Attendance_log";
import TeamAttendance from "./pages/user/mobile/TeamAttendance";

import AdminMobileDashboard from "./pages/admin/mobile/Dashboard";
import AdminDesktopDashboard from "./pages/admin/desktop/Dashboard";
import Locationmaster from "./pages/admin/desktop/Locationmaster";
import Departmentmaster from "./pages/admin/desktop/Departmentmaster";
import Holidaymaster from "./pages/admin/desktop/Holidaymaster";
import Shiftmaster from "./pages/admin/desktop/Shiftmaster";
import Gracetimemaster from "./pages/admin/desktop/Gracetimemaster";
import Designationmaster from "./pages/admin/desktop/Designationmaster";
import Userlistmaster from "./pages/admin/desktop/Userlistmaster";
import Devicemaster from "./pages/admin/desktop/Devicemaster";
import Profilemaster from "./pages/admin/desktop/Profilemaster";
import ProfileLayout from "./layouts/ProfileLayout";
import DesktopLayout from "./layouts/DesktopLayout";
import Report from "./pages/admin/desktop/Report";
import Shiftroster from "./pages/admin/desktop/Shiftroster";
import Weekoffroster from "./pages/admin/desktop/Weekoffroster";
import Themesettings from "./pages/admin/desktop/Themesettings";

import AccessDenied from "./pages/common/AccessDenied";

const router = createBrowserRouter([
  // ── Public routes ──────────────────────────────────
  {
    path: "/",
    element: <Login />,
  },
  {
  path: "/privacy-policy",
  element: <PrivacyPolicy />,
},
  {
    path: "/access-denied",
    element: <AccessDenied />,
  },

  // ── Protected user mobile routes ──────────────────
  {
    path: "/user/mobile/dashboard",
    element: (
      <AuthGuard>
        <UserMobileDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/punchmark",
    element: (
      <AuthGuard>
        <Punchmark />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/attendance",
    element: (
      <AuthGuard>
        <Attendance />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/attendanceform",
    element: (
      <AuthGuard>
        <Attendanceform />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/attendance-log",
    element: (
      <AuthGuard>
        <AttendanceLog />
      </AuthGuard>
    ),
  },

  {
  path: "/user/mobile/team-attendance",
  element: (
    <AuthGuard>
      <TeamAttendance />
    </AuthGuard>
  ),
},
  {
    path: "/user/mobile/leave",
    element: (
      <AuthGuard>
        <Leave />
      </AuthGuard>
    ),
  },

  {
    path: "/user/mobile/approvals",
    element: (
      <AuthGuard>
        <UserApprovals />
      </AuthGuard>
    ),
  },

  {
  path: "/user/mobile/my-requests",
  element: (
    <AuthGuard>
      <UserMyapproval />
    </AuthGuard>
  ),
},
  
  {
    path: "/user/mobile/leaveForm",
    element: (
      <AuthGuard>
        <Leaveform />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/payroll",
    element: (
      <AuthGuard>
        <Payroll />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/holidaylist",
    element: (
      <AuthGuard>
        <Holidaylist />
      </AuthGuard>
    ),
  },
  {
    path: "/user/mobile/profile",
    element: (
      <AuthGuard>
        <Profile />
      </AuthGuard>
    ),
  },

  // ── Protected user desktop routes ────────────────
  {
    path: "/user/desktop/dashboard",
    element: (
      <AuthGuard>
        <UserDesktopDashboard />
      </AuthGuard>
    ),
  },

  // ── Protected admin mobile routes ────────────────
  {
    path: "/admin/mobile/dashboard",
    element: (
      <AuthGuard>
        <AdminMobileDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/punchmark",
    element: (
      <AuthGuard>
        <AdminPunchmark />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/attendance",
    element: (
      <AuthGuard>
        <AdminAttendance />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/approvals",
    element: (
      <AuthGuard>
        <AdminApprovals />
      </AuthGuard>
    ),
  },
  {
  path: "/admin/mobile/my-requests",
  element: (
    <AuthGuard>
      <AdminMyapproval />
    </AuthGuard>
  ),
},
  
  {
    path: "/admin/mobile/attendance-log",
    element: (
      <AuthGuard>
        <AdminAttendanceLog />
      </AuthGuard>
    ),
  },
  {
  path: "/admin/mobile/team-attendance",
  element: (
    <AuthGuard>
      <AdminTeamAttendance />
    </AuthGuard>
  ),
},
  {
    path: "/admin/mobile/attendanceform",
    element: (
      <AuthGuard>
        <AdminAttendanceform />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/leave",
    element: (
      <AuthGuard>
        <AdminLeave />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/leaveForm",
    element: (
      <AuthGuard>
        <AdminLeaveform />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/payroll",
    element: (
      <AuthGuard>
        <AdminPayroll />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/holidaylist",
    element: (
      <AuthGuard>
        <AdminHolidaylist />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/mobile/profile",
    element: (
      <AuthGuard>
        <AdminProfile />
      </AuthGuard>
    ),
  },

  // ── Protected admin desktop routes ────────────────
  {
    path: "/admin/desktop",
    element: (
      <AuthGuard>
        <DesktopLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "dashboard",
        element: <AdminDesktopDashboard />,
      },
      {
        path: "location-master",
        element: <Locationmaster />,
      },
      {
        path: "department-master",
        element: <Departmentmaster />,
      },
      {
        path: "holiday-master",
        element: <Holidaymaster />,
      },
      {
        path: "shift-master",
        element: <Shiftmaster />,
      },
      {
        path: "grace-time-master",
        element: <Gracetimemaster />,
      },
      {
        path: "designation-master",
        element: <Designationmaster />,
      },
      {
        path: "userlist-master",
        element: <Userlistmaster />,
      },
      {
        path: "device-master",
        element: <Devicemaster />,
      },
      {
        path: "report",
        element: <Report />,
      },
      {
        path: "shift-roster",
        element: <Shiftroster />,
      },
      {
        path: "week-off-roster",
        element: <Weekoffroster />,
      },
      {
        path: "theme-settings",
        element: <Themesettings />,
      },
    ],
  },

  {
    path: "/admin/desktop/profile-master",
    element: (
      <AuthGuard>
        <ProfileLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Profilemaster />,
      },
    ],
  },
]);

export default router;
